import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import HTMLDECODE from 'utils/htmlDecode';
import { getDeepLink, getDownloadLink } from '../util/links';

export default class ModalDeepLink extends Component {
  static propTypes = {
    show: PropTypes.bool,
    labels: PropTypes.object,
    id: PropTypes.string,
    onClose: PropTypes.func,
    onClickDeepLink: PropTypes.func,
  };

  static defaultProps = {
    show: false,
    config: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show,
      groupId: null,
    };
    this.dlDownloadContent = getDeepLink(this.props.id);
    this.dlDownloadApp = getDownloadLink(this.props.id);
    this.onDeepLink = this.onDeepLink.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      this.state = {
        show: nextProps.show,
      };
    }
    if (this.props.id !== nextProps.id) {
      this.dlDownloadContent = getDeepLink(nextProps.id);
      this.setState({
        groupId: nextProps.id,
      });
    }
  }

  onDeepLink() {
    this.hide();
    // Agregar a la cola
    this.props.onClickDeepLink();
    if (this.dlDownloadContent !== null) {
      location.href = this.dlDownloadContent;
    }
  }

  hide = () => {
    this.setState({
      show: false,
    });
  };

  render() {
    const { show } = this.state;
    const { labels, onClose } = this.props;

    return (
      <Modal show={show} onExited={onClose} id="modalSocialLevelUp">
        <Modal.Header>
          <button
            className="close close-modal"
            onClick={this.hide}
            type="button"
          >
            x
          </button>
        </Modal.Header>
        <Modal.Body className="text-center modal-body-card-view">
          <i className={labels.modalDownloadIcon} />
          <p
            dangerouslySetInnerHTML={{
              __html: HTMLDECODE(labels.modalInfoFirst),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: HTMLDECODE(labels.modalInfoSecond),
            }}
          />

          <div className="row">
            <a
              className="btn btn-lg btn-default link"
              href={this.dlDownloadApp}
              onClick={onClose}
              target="_blank"
              download
              rel="noopener noreferrer"
            >
              {labels.modalDownloadApp}
            </a>
            <a
              className="btn btn-lg btn-primary link"
              onClick={this.onDeepLink}
            >
              {labels.modalInstalledApp}
            </a>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
